
/* styles */
require("!!../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../node_modules/vue-loader/lib/style-rewriter?id=data-v-43c7358d&scoped=true!../node_modules/vue-loader/lib/selector?type=styles&index=0!./ProductsPage.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductsPage.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-43c7358d!../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductsPage.vue"),
  /* scopeId */
  "data-v-43c7358d",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/ProductsPage.vue
// module id = 293
// module chunks = 2